<!-- 价格说明 -->
<template> 
    <div>
        <el-dialog v-dialogDrag title="价格说明" :visible.sync="priceShow" width="60%" :before-close="handleClose" :close-on-click-modal="false">
            <el-form ref="priceForm" :model="priceForm" label-width="300px" size="mini">
                <el-form-item label="特殊关系确认">
                    <el-input :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="价格影响确认">
                    <el-input :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="与货物有关的特许权使用费支付确认">
                    <el-input :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="公式定价确认">
                    <el-input :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="暂定价格确认">
                    <el-input :disabled="true"></el-input>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="sure">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: {
        priceShow: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            priceForm:{},
        }
    },
    watch: {
    },
    mounted() { 

    },
    methods: { 
        handleClose() {
            this.$emit('priceClose', false);
        },
        sure(){
            // 返回选中值
        }
    }
}
</script>
<style lang="css" scoped>

</style>